import { UserBuilder } from '../../common/users/user-builder';
import { CallType } from './call-type';
import { ExtendedCallStatus } from './extended-call-status';
import { CallPriority } from './call-priority';
import { RandomGenerator } from '../../../test-utils';
import { TicketInfoBuilder } from '../../tickets/ticket-info.builder';
var CallStatsBuilder = /** @class */ (function () {
    function CallStatsBuilder() {
        var ticket = new TicketInfoBuilder().build();
        this.call = {
            id: '000-000-000-000-000',
            queueId: 'bb00bb-b0b0b0b0-9b9b9b9b-9b88b8b',
            type: CallType.CALLBACK,
            user: new UserBuilder().build(),
            status: ExtendedCallStatus.IN_QUEUE,
            userPhoneNumber: { countryCode: '972', number: '545555555' },
            ticket: ticket,
            participants: RandomGenerator.callParticipants(3, true),
            creationDate: RandomGenerator.randomDate(),
            lastUpdateDate: RandomGenerator.randomDate(),
            startDate: RandomGenerator.randomDate(),
            endDate: RandomGenerator.randomDate(),
            queueStartDate: RandomGenerator.randomDate(),
            queueEndDate: RandomGenerator.randomDate(),
            fromTransfer: false,
            priority: CallPriority.NORMAL,
            recordingDeleted: false,
            callDuration: RandomGenerator.randomNumber(20000, 500000),
            callWaitDuration: RandomGenerator.randomNumber(20000, 500000),
            inProgress: false,
            ivrEndDate: RandomGenerator.randomDate(),
            lineId: 'bb00bb-b0b0b0b0-9b9b9b9b-9b88b8b',
            recordingAvailable: false,
            ticketId: ticket.id,
            priorityScore: RandomGenerator.randomNumber(0, 100),
        };
    }
    CallStatsBuilder.prototype.withId = function (id) {
        this.call.id = id;
        return this;
    };
    CallStatsBuilder.prototype.withInProgress = function (inProgress) {
        this.call.inProgress = inProgress;
        return this;
    };
    CallStatsBuilder.prototype.withQueueId = function (queueId) {
        this.call.queueId = queueId;
        return this;
    };
    CallStatsBuilder.prototype.withType = function (type) {
        this.call.type = type;
        return this;
    };
    CallStatsBuilder.prototype.withUser = function (user) {
        this.call.user = user;
        return this;
    };
    CallStatsBuilder.prototype.withUserPhoneNumber = function (userPhoneNumber) {
        this.call.userPhoneNumber = userPhoneNumber;
        return this;
    };
    CallStatsBuilder.prototype.withTicket = function (ticket) {
        this.call.ticket = ticket;
        return this;
    };
    CallStatsBuilder.prototype.withParticipants = function (participants) {
        this.call.participants = participants;
        return this;
    };
    CallStatsBuilder.prototype.withStatus = function (status) {
        this.call.status = status;
        return this;
    };
    CallStatsBuilder.prototype.withFromTransfer = function (isFromTransfer) {
        this.call.fromTransfer = isFromTransfer;
        return this;
    };
    CallStatsBuilder.prototype.withPriority = function (priority) {
        this.call.priority = priority;
        return this;
    };
    CallStatsBuilder.prototype.withPriorityScore = function (priorityScore) {
        this.call.priorityScore = priorityScore;
        return this;
    };
    CallStatsBuilder.prototype.build = function () {
        return this.call;
    };
    return CallStatsBuilder;
}());
export { CallStatsBuilder };
//# sourceMappingURL=call-stats.builder.js.map